module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNpilOo+sIuBgWHW0xL7NQw4gHTPwVAglcUEJA4BcRNQwBWHQm8g1QjEOxj///8PEsgAcvKAuABowy4khQFAqg2I+4Dic0AmMwAZM4DUdCCeAFTgBlUYDlXYA1IIEgObjGRSAZBKA+JNQOwHxJ1AhQth8iiKoRpSQc4B4iqgwo3IcgABBgCnNDULNv89NgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.png
// module id = 1053
// module chunks = 114